// Utils
import { api, removeEmptyFromObject } from "@utils/";

// Constants
import { API_ROUTES } from "@constants/";

// Types
import { TFolderFilter } from "@_types/";

const getAllRanks = async ({ filters }: { filters?: TFolderFilter[] | TFolderFilter }) => {
  const data = removeEmptyFromObject({
    ...filters,
  });

  const response = await api.get(API_ROUTES.ranks, data);

  return response?.data;
};

const getOneRank = async (id: string) => {
  const response = await api.get(`${API_ROUTES.ranks}/${id}`, {});
  return response?.data;
};

const createRank = async (data: unknown) => {
  const response = await api.post(API_ROUTES.ranks, {}, data);
  return response?.data;
};

const updateRank = async (id: string, data: unknown) => {
  const response = await api.patch(`${API_ROUTES.ranks}/${id}`, {}, data);
  return response?.data;
};

const deleteRank = async (id: string) => {
  const response = await api.destroy(`${API_ROUTES.ranks}/${id}`);
  return response;
};

const getRanksNoPagination = async () => {
  const response = await api.get(`${API_ROUTES.ranks}/all`, {});
  return response?.data;
};

export { createRank, deleteRank, getAllRanks, getOneRank, updateRank, getRanksNoPagination };
